import { render, staticRenderFns } from "./OrderDetailsClient.vue?vue&type=template&id=2b274f30&"
import script from "./OrderDetailsClient.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports